<template>
  <div class="app-container">
    <div style="text-align:center;fontSize:20px">广告牌投放协议</div>
    <div style="line-height:30px;text-align:right;">
      编号：{{ adDetail.id }}
    </div>
    <div>甲方（厂商）： 广东哈弗石油能源股份有限公司</div>
    <div>乙方（代理商）：{{ adDetail.partyAName }}</div>
    <div>丙方（门店）：{{ adDetail.partyBName }}</div>
    <div>证件号：{{ adDetail.idNo }}</div>
    <div>
      为了提升丙方店面形象，助力推广“哈弗润滑油”品牌，甲乙丙三方本着真诚合作、互利共赢、相互促进业务发展的原则，根据《中华人民共和国合同法》相关规定，经甲方、乙方、丙方友好协商达成以下协议。
    </div>
    <strong>第一条 协议主旨</strong>
    <ul style="list-style:none">
      <li>
        乙方是甲方指定区域的 哈弗润滑油
        系列产品销售（品牌）运营商，丙方是具有相关资质或营业执照的合法经营组织的负责人，现为了相互促进业务发展，由甲方向丙方提供广告牌制作安装支持，丙方承诺在一定期限内经营乙方哈弗润滑油系列产品。
      </li>
    </ul>
    <strong>第二条 协议内容</strong>
    <ol>
      <li>广告牌（即丙方经营场所）位于： {{ adDetail.advertAddress }} 。</li>
      <li>
        为体现甲方对丙方的支持和维护“哈弗润滑油”品牌形象的统一，广告牌由甲方负责设计，制作、安装广告牌所产生的费用人民币预计为{{
          estimateTotalCost
        }}元，由乙方先行支付，并在安装验收合格后按照甲方规定流程向甲方申请报销，实际广告报销费用以哈弗公司财务部最终核算的金额为准。丙方在安装期间提供相关支持。
      </li>
      <li>
        若丙方擅自更改广告牌设计内容，导致实际安装的广告牌与设计稿不一致的，所产生的广告牌费用由丙方承担。
      </li>
    </ol>
    <strong>第三条 广告投放条件</strong>
    <ol>
      <li>
        自广告牌安装完成之日起，丙方承诺连续经营乙方哈弗润滑油系列产品的时间不得少于{{
          adDetail.minOperationYears
        }}年。
      </li>
      <li>
        在上述期间，丙方不得拆除、变更和修改广告牌，但甲方书面要求丙方拆除、变更和修改的除外。
      </li>
      <li>
        自本合同签订之日起 {{ adDetail.minOperationYears }} 年内（最迟截止{{
          abortDate
        }}）丙方应向乙方购进总价值（依购买时的价格计算）不低人民币
        {{ adDetail.minPurchaseValue }}元（大写：
        {{ digitUppercase(adDetail.minPurchaseValue) }} ）的哈弗润滑油产品。
      </li>
      <li>
        为了促进双方合作友谊，在甲方同意给予丙方广告牌支持的同时，丙方承诺在签订本协议之日起10个工作日内向乙方进购总价值（依购买时的价格计算）不低人民币
        {{ adDetail.firstPurchaseValue }} 元（大写：
        {{ digitUppercase(adDetail.firstPurchaseValue) }} ）的哈弗润滑油产品。
      </li>
    </ol>
    <strong>第四条 甲方权利和义务</strong>
    <ol>
      <li>甲方负责丙方广告牌的设计和修改。</li>
      <li>
        甲方通过合理的市场规划、严格的市场监控等方式保证区域市场及其价格稳定，保证丙方合法权益。同时，甲方和乙方将对市场进行严格管理，严禁窜货、乱价、等行为发生。
      </li>
      <li>甲方有权对丙方经营哈弗润滑油产品的销售行为进行监督和指导。</li>
      <li>
        甲方不定期为丙方提供持续的管理支持，以增强丙方的经营能力和管理水平。
      </li>
    </ol>
    <strong>第五条 乙方权利和义务</strong>
    <ol>
      <li>
        乙方负责与广告公司就广告牌制作、安装事宜进行协商以及签订广告制作合同，并最迟于本协议签订之日起
        30 日内安装完毕。
      </li>
      <li>
        乙方负责寻找具有广告资质的公司洽谈广告安装事务，并监督广告公司在广告牌安装施工时必须遵守国家规定的安全管理制度和操作规范，否则造成的事故由乙方与广告公司共同协商解决。
      </li>
      <li>
        乙方负责与广告公司结清相关费用，费用所产生的争议由乙方解决，但由丙方负责与广告公司对接的除外。
      </li>
      <li>
        乙方应提供质量合格的哈弗润滑油产品给丙方，并提供售后服务，帮助丙方更好地销售哈弗润滑油产品。
      </li>
    </ol>
    <strong>第六条 丙方权利和义务</strong>
    <ol>
      <li>
        丙方可要求在广告中加入丙方电话号码、经营范围等内容，但应当符合甲方整体设计风格。
      </li>
      <li>消费者在使用哈弗润滑油过程中产生疑问的，可要求乙方提供售后服务。</li>
      <li>丙方对自身的经营自负盈亏、自担风险。</li>
      <li>
        负责广告牌的日常维护和管理，因维护或管理不当造成他人损害的，承担相应的责任。
      </li>
      <li>
        遵守甲方公司的经营策略及市场经销秩序，不得进行扰乱甲方市场秩序、侵害甲方商标权、专利权、商誉权等合法权益的行为。
      </li>
      <li>
        丙方须严格按照或不低于甲方指定零售价、批发价销售甲方润滑油产品，严格遵守甲方窜货管理规定及其它规定，接受甲方的监督检查和合理建议。
      </li>
      <li>
        按照甲方统一宣传方式进行产品销售宣传，不得擅自进行虚假宣传或与其他产品进行对比试验等。
      </li>
      <li>丙方应提供营业执照和身份证复印件一份交甲方保存。</li>
    </ol>
    <strong>第七条 违约责任</strong>
    <ol>
      <li>
        若丙方未履行或违反本协议第三条广告投放条件相关内容的，视为丙方根本违约，甲方有权解除本协议，并要求丙方赔偿门头广告制作安装费用。
      </li>
      <li>
        若丙方未履行或违反本协议第六条相关义务的，经甲方书面指出后仍不改正，甲方有权解除本协议，给甲方造成损失的，丙方应当赔偿。
      </li>
      <li>若甲方未履行相关义务的，丙方有权书面通知甲方解除本协议。</li>
      <li>
        若丙方不再销售甲方哈弗润滑油系列产品或者因丙方违约而被甲方解除合同的，丙方应当自上述情况发生之日起15日内拆除由甲方支持制作安装的广告牌，若丙方未拆除的，甲方可书面要求丙方在15日内拆除；经甲方书面要求拆除，丙方仍未拆除的，视为丙方违约，丙方应按广告牌制作安装费用的3倍向甲方支付违约金，或者按丙方累计向乙方进货总额的20%支付违约，最终以核算金额高者为准。
      </li>
      <li>因不可抗力导致无法履行本协议的，三方互不追究违约责任。</li>
    </ol>
    <strong>第八条 其他</strong>
    <ol>
      <li>
        因履行本协议发生争议的，由三方协商解决，协商不成的，任何一方均可以向甲方所在地人民法院起诉解决。
      </li>
      <li>本协议划横线处可手写，但不得涂改，涂改无效。</li>
      <li>
        本协议一式三份，经甲、乙、丙三方签字或盖章后生效，由三方各执一份，具有同等法律效力。本协议所附上的照片、营业执照复印件等同原件同具合法文本。
      </li>
    </ol>
    <ul style="list-style:none">
      <li>甲方（盖章）:广东哈弗石油能源股份有限公司</li>
      <li>法定代表人（签名）：</li>
      <li>地址：广东省东莞市南城街道雅园东路哈弗大厦三楼</li>
      <li>电话：0769-23118455</li>
      <li>日期：{{ adDetail.firstConfirmAt }}</li>
    </ul>
    <ul style="list-style:none">
      <li>乙方（盖章）:{{ adDetail.partyAName }}</li>
      <li>代表人（签名）：{{ adDetail.partyBRealName }}</li>
      <li>地址：{{ userInfo.dealerAddress }}</li>
      <li>电话：{{ userInfo.phone }}</li>
      <li>日期：{{ adDetail.firstConfirmAt }}</li>
    </ul>
    <ul style="list-style:none">
      <li>丙方（盖章或捺印）：{{ adDetail.partyBName }}</li>
      <li>营业执照或身份证：{{ adDetail.idNo }}</li>
      <li>代表人（签名）：{{ adDetail.partyBRealName }}</li>
      <li>经营地址：{{ adDetail.advertAddress }}</li>
      <li>电话：{{ adDetail.partyBPhone }}</li>
      <li>日期：{{ adDetail.firstConfirmAt }}</li>
    </ul>
  </div>
</template>
<script>
export default {
  data() {
    return {
      userInfo: JSON.parse(sessionStorage.getItem("userInfo")),
      adDetail: JSON.parse(localStorage.getItem("apply")),
      estimateTotalCost: localStorage.getItem("estimateTotalCost"),
      abortDate: ""
    };
  },
  mounted() {
    var strTime = this.adDetail.finishAt;
    var date = new Date(Date.parse(strTime.replace(/-/g, "/")));
    date.setFullYear(date.getFullYear() + 2);
    var m = date.getMonth() + 1;
    var d = date.getDate();
    if (m >= 1 && m <= 9) {
      m = "0" + m;
    }
    if (d >= 0 && d <= 9) {
      d = "0" + d;
    }
    var timer = date.getFullYear() + "-" + m + "-" + d;
    this.abortDate = timer;
  },
  methods: {
    digitUppercase(price) {
      const fraction = ["角", "分"];
      const digit = [
        "零",
        "壹",
        "贰",
        "叁",
        "肆",
        "伍",
        "陆",
        "柒",
        "捌",
        "玖"
      ];
      const unit = [
        ["元", "万", "亿"],
        ["", "拾", "佰", "仟"]
      ];
      let num = Math.abs(price);
      let s = "";
      fraction.forEach((item, index) => {
        s += (digit[Math.floor(num * 10 * 10 ** index) % 10] + item).replace(
          /零./,
          ""
        );
      });
      s = s || "整";
      num = Math.floor(num);
      for (let i = 0; i < unit[0].length && num > 0; i += 1) {
        let p = "";
        for (let j = 0; j < unit[1].length && num > 0; j += 1) {
          p = digit[num % 10] + unit[1][j] + p;
          num = Math.floor(num / 10);
        }
        s = p.replace(/(零.)*零$/, "").replace(/^$/, "零") + unit[0][i] + s;
      }
      return s
        .replace(/(零.)*零元/, "元")
        .replace(/(零.)+/g, "零")
        .replace(/^整$/, "零元整");
    }
  }
};
</script>
<style lang="scss" scoped>
.app-container {
  font-size: 12px;

  div {
    padding: 0 20px;
    text-align: left;
    line-height: 30px;
  }

  ol,
  ul {
    padding: 0 20px;
    text-align: left;
    list-style: decimal;
    line-height: 30px;
  }
}
</style>
